import styled from 'styled-components'
import { GRAYSCALE_600, GRADIENT_SELECTED, GRADIENT_SELECTED_OVERLAY, BLUE_PRICE, BLUE_FREE_TAG, BLUE_FREE_BG } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

interface OuterContainerProps {
  $selected?: boolean
}

export const OuterContainer = styled.div<OuterContainerProps>`
  padding: 2px;
  border-radius: 12px;
  background: ${(props: OuterContainerProps) => props.$selected ? GRADIENT_SELECTED : '#FCFCFC'};
  width: 100%;
` as any

interface InnerContainerProps {
  $selected?: boolean
}

export const InnerContainer = styled.div<InnerContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: ${(props: InnerContainerProps) => props.$selected ? GRADIENT_SELECTED_OVERLAY : 'rgba(0, 0, 0, 0.03)'};
  border: ${(props: InnerContainerProps) => props.$selected ? '' : '2px solid #EDEFF3'};
  border-radius: 10px;
  padding: 12px;
  gap: 6px;
` as any

export const PhoneNumber = styled.span`
  font-family: ${INTER.bold};
  color: ${GRAYSCALE_600};
  font-size: 21px;
`

export const RightSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const FreePriceTag = styled.span`
  font-family: ${INTER.medium};
  font-size: 12px;
  color: ${BLUE_FREE_TAG};
  background-color: ${BLUE_FREE_BG};
  padding: 6px;
  border-radius: 5px;
`

export const PriceText = styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${BLUE_PRICE};
  padding: 6px;
`

export const PriceBold = styled.span`
  font-family: ${INTER.bold};
`
